import { TaskNotificationItem } from 'layout/inbox-notifications/close/checklist/task/TaskNotificationItem';

import { ChecklistNotification } from 'types/inbox-notifications/close/ChecklistNotifications';

export function ChecklistNotificationItem({
  type,
  item,
}: {
  type: string[];
  item: ChecklistNotification;
}) {
  const [itemType, ...restOfType] = type;

  switch (itemType) {
    case 'task':
      return <TaskNotificationItem type={restOfType} item={item} />;
    default:
      return <div>Unknown checklist notification type: {type.join('.')}</div>;
  }
}
